module.exports = __webpack_public_path__ + "static/media/Inertia_theory_q3.6dcb9f9b.mp4";